export default "__VITE_ASSET__k62H25Yb__"